import styled from "styled-components";

import ButtonAction, { buttonActionThemes } from "../button-action";

export const Button = styled(ButtonAction).attrs({
  theme: buttonActionThemes.SECONDARY,
  type: "button"
})`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  height: 48px;
  justify-content: center;
  min-width: auto;
  padding: 0;
  width: 48px;

  * {
    box-sizing: border-box;
  }
`;
